module.exports = __webpack_public_path__ + "static/synopsis-4fa1f93532e3de4164871ccdc2c71751.png";